import React from 'react';
import styled from 'styled-components';
import ContentLoader from 'react-content-loader';
import StepWrapper from './StepWrapper';

const Wrapper = styled(ContentLoader)`
  width: 100%;
  box-sizing: border-box;
`;

const Title = () => {
  return (
    <Wrapper speed={1}>
      <rect x="0" y="0" rx="4" ry="4" width="100%" height="20" />
      <rect x="10%" y="40" rx="4" ry="4" width="80%" height="20" />
    </Wrapper>
  );
};

const Field = () => {
  return (
    <Wrapper preserveAspectRatio="xMaxYMin" height={88} speed={1}>
      <rect x="0" y="40" width="100%" height="88" />
    </Wrapper>
  );
};

const LoadingPlaceholder = () => {
  return (
    <StepWrapper>
      <div>
        <Title />
      </div>
      <div style={{ width: '100%' }}>
        <Field />
      </div>
    </StepWrapper>
  );
};

export default LoadingPlaceholder;
